import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AdminSearch from '../components/AdminSearch.js';

const AdminUsers = ({ activeTab }) => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [openUserId, setOpenUserId] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState(null);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('/api/auth/get/all/users');
      setUsers(res.data);
      setFilteredUsers(res.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  useEffect(() => {
    if (activeTab === 'users') {
      fetchUsers();
    }
  }, [activeTab]);

  const toggleVerification = async (userId, isVerified) => {
    Swal.fire({
      title: 'Da li ste sigurni?',
      text: `Želite da ${isVerified ? 'uklonite' : 'dodate'} verifikaciju za ovog korisnika?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, potvrdite!',
      cancelButtonText: 'Otkaži'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.put('/api/auth/verifyUser', {
            userId,
            isVerified: isVerified ? 0 : 1,
          });

          fetchUsers();

          Swal.fire(
            'Uspješno!',
            `Korisnik je ${isVerified ? 'ne' : ''}verifikovan.`,
            'success'
          );
        } catch (err) {
          console.error('Error adding subject:', err);
          Swal.fire('Greška!', 'Došlo je do greške prilikom verifikacije.', 'error');
        }
      }
    });
  };

  const toggleBlock = async (userId, blokiran) => {
    Swal.fire({
      title: 'Da li ste sigurni?',
      text: `Želite da ${blokiran ? 'odblokirate' : 'blokirate'} ovog korisnika?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, potvrdite!',
      cancelButtonText: 'Otkaži'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.put('/api/auth/blockUser', {
            userId,
            blokiran: blokiran ? 0 : 1,
          });

          fetchUsers();

          Swal.fire(
            'Uspješno!',
            `Korisnik je ${blokiran ? 'od' : ''}blokiran.`,
            'success'
          );
        } catch (err) {
          console.error('Greska kod blokiranja:', err);
          Swal.fire('Greška!', 'Došlo je do greške prilikom blokiranja.', 'error');
        }
      }
    });
  };

  const toggleBiography = (userId) => {
    setOpenUserId(openUserId === userId ? null : userId);
  };

  const filterByUserType = (type) => {
    setUserTypeFilter(type);
    if (type === null) {
      setFilteredUsers(users);
    } else {
      setFilteredUsers(users.filter(user => user.id_tipa === type));
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  
  const formatDate2 = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <div>
      <p>Pregled korisnika</p>
      <div className="filter-buttons mb-3">
        <button onClick={() => filterByUserType(2)}>Profesori</button>
        <button onClick={() => filterByUserType(3)}>Učenici</button>
        <button onClick={() => filterByUserType(null)}>Prikaži sve</button>
        <h3 style={{ display: "none" }}>{userTypeFilter}</h3>
      </div>

      <AdminSearch/>

      <table>
        <thead>
          <tr>
            <th>Ime</th>
            <th>Email</th>
            <th>Slika</th>
            <th>Kreirao nalog</th>
            <th>Datum rođenja</th>
            <th>Broj telefona</th>
            <th>Tip korisnika</th>
            <th>Verifikovan (Admin)</th>
            <th>Email Verifikovan</th>
            <th>Blokiran</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user) => (
            <React.Fragment key={user.id_korisnika}>
              <tr>
                <td
                  onClick={() => toggleBiography(user.id_korisnika)}
                  style={{ cursor: 'pointer', color: 'blue' }}
                >
                  {user.ime}
                </td>
                <td>{user.email}</td>
                <td>
                  {user.img ? (
                    <img
                      src={`${user.img}`}
                      alt="Profil slika"
                      width={32}
                      height={32}
                      className="rounded-circle"
                    />
                  ) : (
                    <span>Nema</span>
                  )}
                </td>
                <td>{formatDate2(user.vrijeme_kreiranja)}</td>
                <td>{formatDate(user.datum_rodjenja)}</td>
                <td>{user.broj_telefona}</td>
                <td>{user.id_tipa === 2 ? 'Profesor' : 'Učenik'}</td>
                <td
                  onClick={() => toggleVerification(user.id_korisnika, user.verifikovan)}
                  style={{ cursor: 'pointer', color: user.verifikovan ? 'green' : 'red' }}
                >
                  {user.verifikovan ? 'Da' : 'Ne'}
                </td>
                <td>{user.isVerified ? 'Da' : 'Ne'}</td>
                <td
                  onClick={() => toggleBlock(user.id_korisnika, user.blokiran)}
                  style={{ cursor: 'pointer', color: user.blokiran ? 'red' : 'green' }}
                >
                  {user.blokiran ? 'Da' : 'Ne'}
                </td>
              </tr>
              {openUserId === user.id_korisnika && (
                <tr>
                  <td colSpan="9" className="bio-container">
                    <strong>Biografija:</strong> {user.biografija || 'Nema biografije'}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUsers;